import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Avatar = ({ size, image }) => {
  const avatarClass = classNames('avatar', {
    'avatar--s': size === 's',
    'avatar--l': size === 'l',
  });

  return (
    <img alt="" src={image} className={avatarClass} />
  );
};

Avatar.propTypes = {
  size: PropTypes.string,
  image: PropTypes.string,
};

export default Avatar;



// WEBPACK FOOTER //
// ./library/app/components/Global/Avatars/Avatar.js